<template>
    <v-dialog
        v-model="isActive"
        width="400"
        persistent
        @click:outside.prevent="closeHandle"
    >
        <div class="adjust">
            <div class="adjust__head">
                <h3>
                    {{
                        $t(
                            'pages.wigPage.ordersPagePayments.actions.adjustPayment'
                        )
                    }}
                </h3>
                <v-btn icon color="#55595c" @click="closeHandle">
                    <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
            </div>
            <div class="adjust__content">
                <v-text-field
                    ref="input"
                    v-model="amount"
                    dense
                    outlined
                    :label="$t('pages.wigPage.slideOuts.amount')"
                    type="text"
                    name="amount"
                ></v-text-field>

                <v-textarea
                    v-model="comment"
                    outlined
                    name="comment"
                    :label="$t('pages.wigPage.slideOuts.comment')"
                    rows="2"
                >
                </v-textarea>

                <div
                    v-if="getAllowed(['admin', 'manager'])"
                    class="orders-page-payments__btns"
                >
                    <v-btn
                        :disabled="isSubmitting"
                        width="49%"
                        min-width="80"
                        color="#3bafda"
                        :dark="!isSubmitting"
                        data-test-id="wig-page--payments--add-payment-btn"
                        class="orders-page-payments__btn"
                        @click="handleAdjust"
                    >
                        {{ $t('pages.wigPage.mainActions.confirm') }}
                    </v-btn>
                    <v-btn
                        width="49%"
                        min-width="80"
                        color="#da4453"
                        dark
                        data-test-id="wig-page--payments--add-note-btn"
                        class="orders-page-payments__btn"
                        @click="closeHandle"
                    >
                        {{ $t('pages.wigPage.mainActions.cancel') }}
                    </v-btn>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import modalsMixin from '@/mixins/modals.mixin'
import popUpTypes from '@/types/pop-up-types'
import { mapActions, mapGetters } from 'vuex'
import {
    actionTypes as actionTypesOrders,
    getterTypes as getterTypesOrders,
} from '@/store/modules/orders'
import { readonly } from 'vue'
const { adjustPayment } = popUpTypes

export default {
    name: 'OrderAdjustPayment',
    mixins: [modalsMixin],
    data() {
        return {
            selfName: adjustPayment,
            amount: '',
            comment: '',
            isSubmitting: false,
        }
    },

    computed: {
        ...mapGetters('orders', {
            order: getterTypesOrders.getOrder,
        }),
    },
    watch: {
        isActive(newValue) {
            if (newValue) {
                this.amount = ''
                this.comment = ''
            }
        },
    },
    methods: {
        ...mapActions('orders', {
            adjustPaymentRequest: actionTypesOrders.adjustPayment,
        }),
        handleAdjust: async function () {
            if (!this.order) return

            this.isSubmitting = true

            let payload = {
                amount: this.amount,
            }

            if (this.comment) {
                payload.comment = this.comment
            }

            try {
                await this.adjustPaymentRequest({
                    wig_id: this.order.id,
                    payload,
                })
            } catch (e) {
                console.error(e)
            } finally {
                this.isSubmitting = false
                this.closeHandle()
            }
        },
    },
}
</script>

<style lang="scss">
.adjust {
    background: #fff;

    &__head {
        padding: 20px 14px;
        border-bottom: 1px solid #eceeef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
            font-weight: 400;
        }
    }

    &__content {
        padding: 14px;
    }
}
</style>
